/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchUrl } from '../../../config';
import Loading from '../../Loading/Loading';
import { AllContext } from '../../../AllContext';

function BuklStatusUpdate(props) {
    const route = useNavigate()
    const accessToken = localStorage.getItem('access_token')
    const { edit, setEdit, checkArr, setCheckArr,checkAll,handleCheckAll } = props
    const [isLoading, setIsLoading] = useState(false)
    const { setShowAlert, setAlertText, setAlertVariant } = useContext(AllContext)
    const [orderStatusInput, setOrderStatusInput] = useState('New')
    const handleOrderStatus = (e) => {
        setOrderStatusInput(e.target.value)
    }

    
    const hanldeUpdateStutus = () => {
        setIsLoading(true)
        const orderStatus = new FormData()
        orderStatus.append('order_status', orderStatusInput)
        checkArr.map(data =>

            fetch(`${fetchUrl}/api/order/update/${data}/`, {
                headers: { "Authorization": `Bearer ${accessToken}` },
                method: "PATCH",
                body: orderStatus

            })
                .then(res => {
                    setIsLoading(false)
                    if (res.ok) {
                        route(0)
                        console.log('ok')

                        setShowAlert(true)
                        setAlertText(` Update Success`)
                        setAlertVariant('success')
                    }
                    else {

                        setShowAlert(true)
                        setAlertText(`Fail to update`)
                        setAlertVariant('danger')
                    }

                })
                .catch(() => {
                    setIsLoading(false)
                    setShowAlert(true)
                    setAlertText(`Fail to update`)
                    setAlertVariant('danger')
                })
        )
        setCheckArr([])
    }
const handleExport = () => {
        if (!checkArr || checkArr.length === 0) {
             setShowAlert(true)
                        setAlertText('Please select at least one order to export.')
                        setAlertVariant('danger')
            return;
        }

        // 1. Convert the array of IDs into a comma-separated string
        const idString = checkArr.join(',');

        // 2. Construct the full URL for your Django endpoint
        // Endpoint: /api/orders/export/csv/?ids=101,105,109
        const exportUrl = `${fetchUrl}/api/orders/export/csv/?ids=${idString}`;
        
        // 3. Trigger the file download by navigating the browser to the URL
        // This is the simplest way to initiate a file download from a GET request.
        window.location.href = exportUrl;
    };

const buttonStyle = {
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    backgroundColor: '#4CAF50', // Green color
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    margin: '10px 0',
};
    return (
      <div>
        {isLoading ? <Loading /> : null}

        <div className="my-3">
          {" "}
          <button
            onClick={() => setEdit(!edit)}
            type="button"
            className="btn btn-outline-primary"
          >
            {!edit ? "Select Order" : " Close"}
          </button>
        </div>
        <div>
          {edit ? (
            <div>
              <div className="form-check btn  btn-warning">
                <input
                  id="checkAll"
                  className="form-check-input ms-0"
                  type="checkbox"
                  checked={checkAll}
                  disabled={!edit}
                  onChange={handleCheckAll}
                  aria-label="Check All"
                />
                <label className="form-check-label ms-1" htmlFor="checkAll">
                  Check All
                </label>
              </div>
              <div className="col-md-3  mt-3 mb-1 pb-1">
                <select
                  className="form-select"
                  name="order-status"
                  onChange={(e) => handleOrderStatus(e)}
                >
                  <option value="New">New</option>
                  <option value="Pending">Pending</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="Confirmed">Confirmed</option>
                  <option value="Courier">Courier</option>
                  <option value="Delivered">Delivered</option>
                  <option value="Return">Return</option>
                  <option value="Money Collected">Money Collected</option>
                </select>
                <button
                  onClick={hanldeUpdateStutus}
                  className="btn btn-dark my-3 px-5"
                  type="button"
                >
                  Update
                </button>
                <div>
                  <button
                    type="button"
                    onClick={handleExport}
                    // Disable the button if no orders are selected
                    disabled={!checkArr || checkArr.length === 0}
                    style={buttonStyle}
                  >
                    Export Selected Orders ({checkArr.length})
                  </button>
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
}

export default BuklStatusUpdate;